import { createSlice } from '@reduxjs/toolkit'
import { v4 as uuidv4 } from 'uuid'

export const ERROR_NOTIFICATION = 'ERROR_NOTIFICATION'
export const SUCCESS_NOTIFICATION = 'SUCCESS_NOTIFICATION'

export const GENERIC_ERROR_MESSAGE =
  'There was an error communicating with the server'

const initialState = { queue: [] }

const slice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    showNotification(state, { payload }) {
      state.queue.splice(0, 0, payload)
      return state
    },
    clearNotification(state, action) {
      let { id } = action.payload
      state.queue = state.queue.filter(n => n.id !== id)
      return state
    },
  },
})

export const { clearNotification, showNotification } = slice.actions

export const showError = (message = GENERIC_ERROR_MESSAGE) => {
  const payload =
    typeof message === 'string'
      ? {
          message: `Uh-oh! Something's not quite right, but stay cool\n\n${message}`,
          image: 'tomato',
        }
      : message
  return showNotification({
    id: uuidv4(),
    type: ERROR_NOTIFICATION,
    ...payload,
  })
}

export const showSuccess = message => {
  const payload =
    typeof message === 'string'
      ? {
          message,
        }
      : message
  return showNotification({
    id: uuidv4(),
    type: SUCCESS_NOTIFICATION,
    ...payload,
  })
}

export default slice.reducer
